import { API_BASE_URL } from "@/libs/constants/apis";
import { fetchUtil } from "@/libs/fetch";

export const fetchArticles: (data: { [key: string]: string }) => Promise<any> = async ({
  categorySlug,
  pillarSlug,
  clusterSlug,
  tagName,
}) => {
  const body = {
    ...(categorySlug ? { CategorySlug: [categorySlug] } : {}),
    ...(pillarSlug ? { PillarSlug: [pillarSlug] } : {}),
    ...(clusterSlug ? { ClusterSlug: [clusterSlug] } : {}),
    ...(tagName ? { TagName: [tagName] } : {}),
    pagination: {
      pageNo: 1,
      pageSize: 5,
    },
    condition: "and",
  };

  return await fetchUtil({
    url: `${API_BASE_URL}/api/articles/filterArticles`,
    method: "POST",
    body,
    useToken: false,
    credentials: "",
    ctype: "",
  });
};
